var _style, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _defs, _path, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRoadSign(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_14838",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000161619195778956370740000017362022249552663190_);}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6246",
    y: 19.1,
    width: 0.9,
    height: 0.9
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6247",
    x: 5.1,
    y: 19.1,
    width: 0.9,
    height: 0.9
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6248",
    x: 2.6,
    y: 21.7,
    width: 0.9,
    height: 0.9
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6249",
    x: 0.9,
    y: 20.8,
    width: 0.9,
    height: 0.9
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6250",
    x: 4.3,
    y: 20.8,
    width: 0.9,
    height: 0.9
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6251",
    x: 0.9,
    y: 17.4,
    width: 0.9,
    height: 0.9
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6252",
    x: 16.3,
    y: 19.1,
    width: 0.9,
    height: 0.9
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6253",
    x: 21.4,
    y: 19.1,
    width: 0.9,
    height: 0.9
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6254",
    x: 18.9,
    y: 21.7,
    width: 0.9,
    height: 0.9
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6255",
    x: 17.2,
    y: 20.8,
    width: 0.9,
    height: 0.9
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6256",
    x: 20.6,
    y: 20.8,
    width: 0.9,
    height: 0.9
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6257",
    x: 5.1,
    y: 1.5,
    width: 0.9,
    height: 0.9
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6258",
    x: 6.9,
    y: 2.4,
    width: 0.9,
    height: 0.9
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6259",
    x: 2.6,
    y: 4.1,
    width: 0.9,
    height: 0.9
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6260",
    x: 3.4,
    y: 5.8,
    width: 0.9,
    height: 0.9
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6261",
    x: 3.4,
    y: 2.4,
    width: 0.9,
    height: 0.9
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6262",
    x: 21.9,
    y: 9.2,
    width: 0.9,
    height: 0.9
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6263",
    x: 22.7,
    y: 7.5,
    width: 0.9,
    height: 0.9
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6264",
    x: 23.2,
    y: 5.8,
    width: 0.9,
    height: 0.9
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6265",
    x: 21.9,
    y: 2.4,
    width: 0.9,
    height: 0.9
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6266",
    x: 20.2,
    y: 1.5,
    width: 0.9,
    height: 0.9
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6267",
    x: 22.7,
    y: 4.1,
    width: 0.9,
    height: 0.9
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6268",
    x: 16.7,
    y: 1.5,
    width: 0.9,
    height: 0.9
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6269",
    x: 18.4,
    y: 1.1,
    width: 0.9,
    height: 0.9
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14834"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    y: 0.6,
    width: 24,
    height: 22.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000025408990802412291380000010307609820218706823_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14833",
    style: {
      clipPath: "url(#SVGID_00000025408990802412291380000010307609820218706823_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_29528",
    d: "M19.7,18.2H5.1c-1.9,0-3.4-1.5-3.4-3.4c0-0.7,0.2-1.4,0.6-1.9L9.6,2.1c1.1-1.6,3.2-2,4.8-0.9 c0.4,0.2,0.7,0.6,0.9,0.9l7.3,10.7c1.1,1.6,0.7,3.7-0.9,4.8C21.1,18,20.4,18.2,19.7,18.2 M12.4,1.5c-0.9,0-1.7,0.4-2.1,1.1 L3,13.4c-0.8,1.2-0.5,2.8,0.7,3.6c0.4,0.3,0.9,0.4,1.4,0.4h14.6c1.4,0,2.6-1.2,2.6-2.6c0-0.5-0.2-1-0.4-1.4L14.6,2.6 C14.1,1.9,13.3,1.5,12.4,1.5"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6270",
    x: 9.9,
    y: 5.4,
    width: 0.9,
    height: 10.7
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6271",
    x: 14.2,
    y: 5.4,
    width: 0.9,
    height: 10.7
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6272",
    x: 8.6,
    y: 7.5,
    width: 7.7,
    height: 0.9
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6273",
    x: 8.6,
    y: 10.5,
    width: 7.7,
    height: 0.9
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6274",
    x: 8.6,
    y: 13.5,
    width: 7.7,
    height: 0.9
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6275",
    x: 9.9,
    y: 17.8,
    width: 0.9,
    height: 5.6
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6276",
    x: 14.2,
    y: 17.8,
    width: 0.9,
    height: 5.6
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadSign);
export default __webpack_public_path__ + "static/media/road-sign.d0f583c0a2b476719b449e0d00b97f78.svg";
export { ForwardRef as ReactComponent };